<script setup lang="ts">
const props = defineProps<{
  width?: string | number;
}>();
</script>
<template>
  <div data-testid="spin-loader" class="d-flex justify-center align-center">
    <v-progress-circular indeterminate color="primary" :width="props?.width" />
  </div>
</template>
